import { Link } from 'react-router-dom';

const PRESALE_CONTRACT = '0x8E8dE6045891E729aDAd6f8fFEA1270734943bCf';

export function Footer() {
  return (
    <footer className="mt-24 border-t border-paper-300 bg-paper-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8">
          <div className="col-span-2">
            <div className="font-display font-bold text-xl text-gradient inline-block">
              AltCoinsMoney
            </div>
            <p className="mt-3 text-sm text-ink-600 max-w-xs">
              $AIML presale on Polygon. Buy early, refer friends, climb the tiers — earn up
              to 22% USDT commissions plus AIML bonus rewards.
            </p>
          </div>
          <div>
            <div className="font-display font-semibold text-sm uppercase tracking-wider text-ink-700 mb-3">
              Product
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/buy" className="text-ink-600 hover:text-ink">
                  Buy $AIML
                </Link>
              </li>
              <li>
                <Link to="/refer" className="text-ink-600 hover:text-ink">
                  Refer & Earn
                </Link>
              </li>
              <li>
                <Link to="/roadmap" className="text-ink-600 hover:text-ink">
                  Roadmap
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <div className="font-display font-semibold text-sm uppercase tracking-wider text-ink-700 mb-3">
              Resources
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <a
                  href="/AIML-Whitepaper.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-600 hover:text-ink"
                >
                  Whitepaper
                </a>
              </li>
              <li>
                <a
                  href="/AIML-Audit.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-600 hover:text-ink"
                >
                  Security Audit
                </a>
              </li>
              <li>
                <a
                  href={`https://polygonscan.com/address/${PRESALE_CONTRACT}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-ink-600 hover:text-ink"
                >
                  View Contract
                </a>
              </li>
            </ul>
          </div>
          <div>
            <div className="font-display font-semibold text-sm uppercase tracking-wider text-ink-700 mb-3">
              Company
            </div>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-ink-600 hover:text-ink">
                  About
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-ink-600 hover:text-ink">
                  Contact
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-paper-300 flex flex-col md:flex-row md:items-center justify-between gap-3 text-xs text-ink-600">
          <div>© {new Date().getFullYear()} AltCoinsMoney. All rights reserved.</div>
          <div className="flex flex-wrap gap-4">
            <a
              href="/terms.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-ink"
            >
              Terms &amp; Conditions
            </a>
            <a
              href="/privacy.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-ink"
            >
              Privacy Policy
            </a>
          </div>
          <div className="font-mono">
            $AIML · Polygon · ERC-20
          </div>
        </div>
      </div>
    </footer>
  );
}
